import PremiumView from './PremiumView';

export default PremiumView;
